"use strict";
// here we put all global variables
Object.defineProperty(exports, "__esModule", { value: true });
exports.DS = exports.WEB_APP = void 0;
exports.WEB_APP = {
    MAX_WIDTH_HEADER: "1328",
    MAX_WIDTH_SEARCH_BAR: "1089",
    MAX_WIDTH_HOME_SCREEN_CONTENT: "1150",
    MAX_WIDTH_HOME_SCREEN_WITH_BUTTONS: "1198", // MAX_WIDTH_HOME_SCREEN_CONTENT + 2 x 38px carousel button width
    MAX_WIDTH_CONTAINER: "869",
    SHOW_CONTENT_AS_MODAL_BP: "1024",
    MODAL_CONTENT_WIDTH: "600",
    MODAL_WIDTH: "600",
    MODAL_HEIGHT: "750",
};
exports.DS = {};
